import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { getAllPhases } from "../../services/users";

interface Props {
  onPhaseChange: (selectedPhase: any) => void;
  style?: any;
  baseSelected?: boolean;
  isAll?: boolean;
}

const PhaseSelect = ({
  onPhaseChange,
  style,
  baseSelected = true,
  isAll = false,
}: Props) => {
  const [phases, setPhases] = useState<any>([]);
  const [selectedPhase, setSelectedPhase] = useState<any>({});

  const fetchAllPhases = () => {
    getAllPhases().then((res) => {
      if (Array.isArray(res)) {
        console.log("res", res);
        if (baseSelected) setSelectedPhase(res?.[0]);
        setPhases([...res]);
      }
    });
  };

  useEffect(() => {
    fetchAllPhases();
  }, []);

  useEffect(() => {
    console.log("selectedPhase", selectedPhase);
    onPhaseChange(selectedPhase);
  }, [selectedPhase?.phase_id]);

  const onChange = (val: any, option: any) => {
    console.log("value", val, option);
    setSelectedPhase({ ...option });
  };
  return (
    <>
      {phases.length > 0 && (
        <Select
          style={{ marginRight: 10, width: 100, ...style }}
          defaultValue={
            isAll ? "ALL" : baseSelected ? selectedPhase?.phase_id : null
          }
          onChange={onChange}
        >
          {isAll && (
            <Select.Option
              value={"ALL"}
              phase_id={"ALL"}
              phase_name={"ALL"}
              edit_enabled={false}
            >
              All
            </Select.Option>
          )}
          {phases?.map((item: any) => (
            <Select.Option
              value={item.phase_id}
              phase_id={item.phase_id}
              phase_name={item.phase_name}
              edit_enabled={item.edit_enabled == 1}
            >
              {item.phase_name}
            </Select.Option>
          ))}
        </Select>
      )}
    </>
  );
};

export default PhaseSelect;
